import { render, staticRenderFns } from "./AscLabelBox.vue?vue&type=template&id=6f0b1976&scoped=true&"
import script from "./AscLabelBox.vue?vue&type=script&lang=js&"
export * from "./AscLabelBox.vue?vue&type=script&lang=js&"
import style0 from "./AscLabelBox.vue?vue&type=style&index=0&id=6f0b1976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0b1976",
  null
  
)

export default component.exports